const sidebarItems = [
  {
    name: 'Beneficiários',
    icon: 'icon-user',
    routes: [
      {
        name: 'Beneficiários',
        subject: 'Associados',
        path: '/Associados',
        icon: 'icon-user',
      },
      {
        name: 'Veículos',
        subject: 'Veículos',
        path: '/veiculos',
        icon: 'icon-truck',
      },
    ],
  },
  {
    name: 'Propostas',
    icon: 'icon-file-text',
    routes: [
      {
        name: 'Nova Proposta',
        subject: 'Cotações',
        path: '/novaProposta/Interno',
        icon: 'icon-file-text',
      },
      {
        name: 'Painel Propostas',
        subject: 'Cotações',
        path: '/Cotacoes',
        icon: 'icon-archive',
      },
      {
        name: 'Ranking Cadastro',
        subject: 'Ranking Cadastro',
        path: '/cadastro-ranking',
        icon: 'icon-award',
      },
      {
        name: 'Vistoria',
        subject: 'Vistorias',
        path: '/Vistorias',
        icon: 'icon-camera',
      },
      {
        name: 'Pré Propostas',
        subject: 'Pré Cotações',
        path: '/Pre-Cotacoes',
        icon: 'icon-clock',
      },
    ],
  },
  {
    name: 'Eventos',
    icon: 'icon-minimize-2',
    routes: [
      {
        name: 'Novo Evento',
        subject: 'Eventos',
        path: '/novo-evento',
        icon: 'icon-minimize-2',
      },
      {
        name: 'Painel Evento',
        subject: 'Eventos',
        path: '/eventos',
        icon: 'icon-minimize',
      },
      {
        name: 'Painel - Beta',
        subject: 'Painel de Eventos',
        path: '/eventos/beta',
        icon: 'icon-minimize',
      },
      {
        name: 'Listagem',
        subject: 'Listagem de Eventos',
        path: '/eventos/listagem',
        icon: 'icon-trending-up',
      },
      {
        name: 'Configurações',
        subject: 'Configuração de eventos',
        path: '/eventos/configuracoes',
        icon: 'icon-settings',
      },
      {
        name: 'Monitoramento',
        subject: 'Monitoramento de Eventos',
        path: '/eventos/monitoramento',
        icon: 'icon-eye',
      },
    ],
  },
  {
    name: 'Propostas B2C',
    icon: 'icon-monitor',
    routes: [
      {
        name: 'Propostas B2C',
        subject: 'Cotações B2C',
        path: '/CotacoesB2C',
        icon: 'icon-monitor',
      },
      {
        name: 'Painel de Leads B2C',
        subject: 'Painel de Leads B2C',
        path: '/PainelLeadsB2C',
        icon: 'icon-layout',
      },
    ],
  },
  {
    name: 'Financeiro',
    icon: 'icon-dollar-sign',
    routes: [
      {
        name: 'Fechamento',
        subject: 'Fechamento',
        path: '/fechamento',
        icon: 'icon-dollar-sign',
      },
      {
        name: 'Painel Financeiro',
        subject: 'Painel Financeiro',
        path: '/PainelFinanceiro',
        icon: 'icon-layout',
      },
      {
        name: 'Arquivo Remessa',
        subject: 'Arquivo Remessa',
        path: '/ArquivoRemessa',
        icon: 'icon-send',
      },
      {
        name: 'Arquivo Retorno',
        subject: 'Arquivo Retorno',
        path: '/ArquivoRetorno',
        icon: 'icon-package',
      },
      {
        name: 'Extrato',
        subject: 'Extrato',
        path: '/Extrato',
        icon: 'icon-file',
      },
      {
        name: 'Gestão Status',
        subject: 'Gestão Status',
        path: '/gestao-status',
        icon: 'icon-settings',
      },
      {
        name: 'Pagamentos Inconsistentes',
        subject: 'Pagamentos Inconsistentes',
        path: '/pagamentos-inconsistentes',
        icon: 'icon-credit-card',
      },
    ],
  },
  {
    name: 'Comercial',
    icon: 'icon-bar-chart-2',
    routes: [
      {
        name: 'Metas Por Regionais',
        subject: 'Metas Por Regionais',
        path: '/Metas',
        icon: 'icon-bar-chart-2',
      },
      {
        name: 'Programa de Afiliados',
        subject: 'Programa de Afiliados',
        path: '/programaAfiliados',
        icon: 'icon-users',
      },
    ],
  },
  {
    name: 'Relacionamento',
    icon: 'icon-x-circle',
    routes: [
      {
        name: 'Cancelamento',
        subject: 'Cancelamento',
        path: '/Cancelamentos',
        icon: 'icon-x-circle',
      },
      {
        name: 'Ouvidoria',
        subject: 'Ouvidoria',
        path: '/Ouvidoria',
        icon: 'icon-mic',
      },
      {
        name: 'Chamados Internos',
        subject: 'Chamados Internos',
        path: '/ChamadosInternos',
        icon: 'icon-message-circle',
      },
    ],
  },
  {
    name: 'Assistência',
    icon: 'icon-list',
    routes: [
      {
        name: 'Checklist',
        subject: 'Checklist',
        path: '/Checklist',
        icon: 'icon-list',
      },
      {
        name: 'Fale com Especialista',
        subject: 'Fale com Especialista',
        path: '/Chamado',
        icon: 'icon-phone-call',
      },
    ],
  },
  {
    name: 'Relatórios',
    icon: 'icon-bar-chart',
    routes: [
      {
        name: 'Crescimento',
        subject: 'Crescimento',
        path: '/Graficos/Crescimento',
        icon: 'icon-bar-chart',
      },
      {
        name: 'Vendas',
        subject: 'Vendas',
        path: '/Graficos/Vendas',
        icon: 'icon-shopping-bag',
      },
      {
        name: 'Cancelamentos',
        subject: 'Cancelamentos',
        path: '/Graficos/Cancelamentos',
        icon: 'icon-x-square',
      },
      {
        name: 'Dinâmicos',
        subject: 'Dinamicos',
        path: '/Dinamicos',
        icon: 'icon-grid',
      },
      {
        name: 'Consolidado',
        subject: 'Consolidado',
        path: '/Consolidado',
        icon: 'icon-link',
      },
      {
        name: 'Super Ranking',
        subject: 'Super Ranking',
        path: '/SuperRanking',
        icon: 'icon-award',
      },
      {
        name: 'Pódio Anual',
        subject: 'Pódio Anual',
        path: '/PodioAnual',
        icon: 'icon-award',
      },
    ],
  },
  {
    name: 'Make More',
    icon: 'icon-trending-up',
    routes: [
      {
        name: 'Listagem Make More',
        subject: 'Make More - Listagem',
        sidebarPermissionSubject: 'Pode Visualizar Listagem Make More',
        path: '/makemore',
        icon: 'icon-trending-up',
      },
      {
        name: 'Configurações',
        subject: 'Make More - Configurações',
        sidebarPermissionSubject: 'Pode Visualizar Configurações',
        path: '/makemore/configuracao',
        icon: 'icon-settings',
      },
    ],
  },
  {
    name: 'Fecha Bem',
    icon: 'icon-trending-up',
    routes: [
      {
        name: 'Listagem',
        subject: 'Fecha Bem - Listagem',
        sidebarPermissionSubject: 'Pode Visualizar Listagem',
        path: '/fecha-bem',
        icon: 'icon-trending-up',
      },
      {
        name: 'Configurações',
        subject: 'Fecha Bem - Configurações',
        sidebarPermissionSubject: 'Pode Visualizar Configurações',
        path: '/fecha-bem/configuracoes',
        icon: 'icon-settings',
      },
    ],
  },
  {
    name: 'Marketing',
    icon: 'icon-layout',
    routes: [
      {
        name: 'Painel de Leads',
        subject: 'Painel de Leads',
        path: '/marketing/painel-de-leads',
        icon: 'icon-layout',
      },
    ],
  },
  {
    name: 'Cadastros',
    icon: 'icon-briefcase',
    routes: [
      {
        name: 'Empresa',
        subject: 'Empresa',
        path: '/empresa',
        icon: 'icon-briefcase',
      },
      {
        name: 'Usuário',
        subject: 'Usuário',
        path: '/usuarios',
        icon: 'icon-user-plus',
      },
      {
        name: 'Vistoriador',
        subject: 'Vistoriador',
        path: '/vistoriadores',
        icon: 'icon-search',
      },
      {
        name: 'Divisão',
        subject: 'Divisão',
        path: '/divisoes',
        icon: 'icon-code',
      },
      {
        name: 'Regional',
        subject: 'Regional',
        path: '/regionais',
        icon: 'icon-codepen',
      },
      {
        name: 'Setor',
        subject: 'Setor',
        path: '/setores',
        icon: 'icon-sliders',
      },
      {
        name: 'Tipo de Atendimento',
        subject: 'Tipo de Atendimento',
        path: '/tipoAtendimento',
        icon: 'icon-check',
      },
      {
        name: 'Perfil de Usuário',
        subject: 'Perfil de Usuário',
        path: '/perfis',
        icon: 'icon-user-check',
      },
      {
        name: 'Contas Bancárias',
        subject: 'Contas Bancárias',
        path: '/contasBancarias',
        icon: 'icon-book-open',
      },
      {
        name: 'Carteira de Cobrança',
        subject: 'Carteira de Cobrança',
        path: '/carteiraCobranca',
        icon: 'icon-book',
      },
      {
        name: 'Permissões',
        subject: 'Permissões',
        path: '/permissoes',
        icon: 'icon-check-circle',
      },
      {
        name: 'Mensageria',
        subject: 'Mensageria',
        path: '/mensageria',
        icon: 'icon-smartphone',
      },
      {
        name: 'Fornecedor',
        subject: 'Fornecedor',
        path: '/fornecedor',
        icon: 'icon-disc',
      },
      {
        name: 'Classe',
        subject: 'Classe',
        path: '/classe',
        icon: 'icon-bookmark',
      },
      {
        name: 'Apólice',
        subject: 'Apólice',
        path: '/apolice',
        icon: 'icon-clipboard',
      },
      {
        name: 'Agregados',
        subject: 'Agregados',
        path: '/agregados',
        icon: 'icon-truck',
      },
      {
        name: 'Distribuição de Cobranças',
        subject: 'Distribuição de Cobrança',
        path: '/carteira-distribuicao',
        icon: 'icon-book',
      },
    ],
  },
  {
    name: 'Configurações',
    icon: 'icon-shield',
    routes: [
      {
        name: 'Produto',
        subject: 'Produto',
        path: '/produtos',
        icon: 'icon-shield',
      },
      {
        name: 'Contrato',
        subject: 'Contrato',
        path: '/contrato',
        icon: 'icon-edit-2',
      },
      {
        name: 'Campanha',
        subject: 'Campanha',
        path: '/campanha',
        icon: 'icon-tag',
      },
      {
        name: 'Tipo de Pagamento',
        subject: 'Tipo de Pagamento',
        path: '/tipoPagamento',
        icon: 'icon-percent',
      },
      {
        name: 'Benefícios / Coberturas',
        subject: 'Benefícios / Coberturas',
        path: '/beneficios',
        icon: 'icon-map',
      },
      {
        name: 'Tipo de Foto',
        subject: 'Tipo de Foto',
        path: '/tipoFotos',
        icon: 'icon-image',
      },
      {
        name: 'Tipos de Arquivos Vistoria',
        subject: 'Tipos de Arquivos Vistoria',
        path: '/tipos-arquivos-vistoria',
        icon: 'icon-image',
      },
      {
        name: 'Restrições',
        subject: 'Restrições',
        path: '/restricoes',
        icon: 'icon-slash',
      },
      {
        name: 'Integração SGA',
        subject: 'Integração SGA',
        path: '/integracaoSGA',
        icon: 'icon-settings',
      },
      { name: 'Status', subject: 'Status', path: '/status', icon: 'icon-star' },
      {
        name: 'Integrações',
        subject: 'Integrações',
        path: '/integracoes',
        icon: 'icon-git-pull-request',
      },
    ],
  },
  {
    name: 'Tabelas',
    icon: 'icon-play',
    routes: [
      {
        name: 'Simulador',
        subject: 'Simulador',
        path: '/simulador',
        icon: 'icon-play',
      },
      {
        name: 'Grupo de Veículos',
        subject: 'Grupo de Veículos',
        path: '/grupoVeiculos',
        icon: 'icon-database',
      },
      {
        name: 'Tabelas',
        subject: 'Tabelas',
        path: '/tabelas',
        icon: 'icon-layers',
      },
      {
        name: 'Black List',
        subject: 'Black List',
        path: '/blackList',
        icon: 'icon-trash',
      },
      {
        name: 'Lista Rastreadores',
        subject: 'Lista Rastreadores',
        path: '/listRastreadores',
        icon: 'icon-compass',
      },
      {
        name: 'Lista Participações',
        subject: 'Lista Participações',
        path: '/listParticipacoes',
        icon: 'icon-align-justify',
      },
    ],
  },
];

export default sidebarItems;
